import React from "react";
import {
  UserLoggedInNavigatorParamList,
  UserLoggedInNavigatorScreenProps,
} from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { HeaderButton } from "../../components";
import { useTheme } from "arkh";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { KPIContent } from "./KPIContent";
import { KPIMainNavigationProps } from "./KPIMainNavigationProps";

export type ParamList = {
  KPIMain: UserLoggedInNavigatorParamList["KPI"];
};
const Stack = createNativeStackNavigator<ParamList>();

export const KPI = withWebModal(InnerKPI, true);

function InnerKPI(props: UserLoggedInNavigatorScreenProps<"KPI">) {
  const theme = useTheme();
  return (
    <Stack.Navigator>
      <Stack.Screen
        name="KPIMain"
        component={KPIMain}
        initialParams={props.route.params}
        options={{
          headerShown: true,
          headerShadowVisible: false,
          headerTitle: props.route.params.routineTitle,
          headerStyle: {
            backgroundColor: theme.surface,
          },
          contentStyle: {
            backgroundColor: theme.surface,
          },
          headerLeft: () => (
            <HeaderButton
              type="DONE"
              onPress={props.navigation.goBack}
              nativeHeader
            />
          ),
        }}
      />
    </Stack.Navigator>
  );
}

function KPIMain(props: KPIMainNavigationProps) {
  return (
    <KPIContent
      navigation={props.navigation}
      route={props.route}
      routineTitle={props.route.params.routineTitle}
      key={props.route.params.routineId + props.route.params.sequenceNumber}
      routineId={props.route.params.routineId}
      sequenceNumber={props.route.params.sequenceNumber}
      teamId={props.route.params.teamId}
      sectionIds={props.route.params.sectionIds}
    />
  );
}
